import React, { useRef, useState, useEffect, memo, useMemo } from "react";
import Slider from "react-slick";
import { Box, IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ReactPlayer from "react-player";
import { TYPEVIDEO } from "../../helpers/Config";

const CustomCarousel = ({ media, initialSlide = 0, handleCloseViewMedia }) => {
  const sliderRef = useRef(null);
  const videoRefs = useRef([]); 
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(initialSlide);
      setTimeout(() => setIsReady(true), 100);
    }
  }, [initialSlide]);

  const settings = useMemo(
    () => ({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      swipe: true,
      swipeToSlide: true,
      touchThreshold: 15,
      centerMode: false,
      arrows: true,
      lazyLoad: "ondemand",
      beforeChange: (current, next) => {
        if (videoRefs.current[current]) {
          videoRefs.current[current].seekTo(0);
          videoRefs.current[current].getInternalPlayer()?.pause?.();
        }
      },
    }),
    []
  );

  const renderMedia = useMemo(() => {
    return media?.map((item, index) => {
      if (item.type === TYPEVIDEO) {
        return (
          <ReactPlayer
            key={item.url + index}
            ref={(el) => (videoRefs.current[index] = el)}
            url={item.url}
            light={item.preview}
            playing={initialSlide === index ? true : false} 
            controls={true}
            loop={true}
            config={{
              file: {
                attributes: {
                  // crossOrigin: "anonymous",
                  // preload: "metadata",
                },
                forceVideo: true,
              },
            }}
            className="responsive-player--modal"
            width="100%"
            height="100%"
          />
        );
      }
      return (
        <Box
          key={item.url + index}
          component={"img"}
          src={item.url}
          alt={`Slide ${index}`}
          sx={{
            width: "100% !important",
            maxHeight: "calc(95% - 40px) !important",
            objectFit: "cover",
            borderRadius: "0",
          }}
        />
      );
    });
  }, [media]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        padding: "20px 0",
        position: "relative",
        visibility: isReady ? "visible" : "hidden",
        "& .slick-slider": {
          height: "100%",
        },
        "& .slick-list": {
          height: "100%",
          margin: "0 -10px",
        },
        "& .slick-track": {
          height: "100%",
        },
        "& .slick-slide": {
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        "& .slick-arrow::before": {
          fontSize: "40px !important",
          color: "#fff",
        },
        "& .slick-prev": {
          width: "40px !important",
          height: "40px !important",
          zIndex: 10000,
          left: "3px",
        },
        "& .slick-next": {
          width: "40px !important",
          height: "40px !important",
          zIndex: 10000,
          right: "3px",
        },
      }}
    >
      <IconButton
        onClick={handleCloseViewMedia}
        sx={{
          position: "absolute",
          top: "-3px",
          right: "-3px",
          zIndex: "100",
        }}
      >
        <CancelIcon sx={{ width: "40px !important", height: "40px !important" }} />
      </IconButton>
      <Slider ref={sliderRef} {...settings}>
        {renderMedia}
      </Slider>
    </Box>
  );
};

export default memo(CustomCarousel);
